import React from "react";
import styles from "../ADD/addComodity.module.css";
import { useLocation } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { SweetAlert } from "../../../../helpers/helper";
import { post } from "../../../../components/api";
import { useNavigate } from "react-router-dom";

const UpdateCommodity = () => {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Commodity name is required"),
    description: Yup.string().required("description is required"),
  });

  const location = useLocation();
  const data = location.state.data;
  const navigate = useNavigate();

  const handleUpdate = async (values, resetForm) => {
    const response = await post("admin/tms/update/commodities", {
      id: data._id,
      name: values.name,
      description: values.description,
    });
    if (response.status == 200) {
      setTimeout(() => {
        navigate("/tms/commodities");
      }, 1000);
      SweetAlert("Commodity Added Successfully", false);
      resetForm();
    } else {
      SweetAlert(response?.message || "error adding commodity", true);
    }
  };
  return (
    <div className={styles.MainDiv}>
      <div className={styles.HeadDiv}>
        <p className={styles.Heading}> Update Commodity</p>
      </div>
      <div className={styles.ContentDiv}>
        <Formik
          initialValues={{
            name: data.name || "",
            description: data.description || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            handleUpdate(values, resetForm);
          }}
        >
          {(formik) => {
            const { resetForm } = formik;
            return (
              <Form>
                <div className="row">
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Commodity name</label>
                    <input
                      className="form-control input-field"
                      id="name"
                      name="name"
                      placeholder="Enter Commodity name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="field-error ">{formik.errors.name}</div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Description</label>
                    <input
                      className="form-control input-field"
                      id="description"
                      name="description"
                      placeholder="Enter Address Line 1"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.description}
                    />
                    {formik.touched.description && formik.errors.description ? (
                      <div className="field-error ">
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-12 col-lg-12 col-xs-12 mt-3">
                    <div className={styles.buttons}>
                      <button
                        type="button"
                        className={styles.CancelButton}
                        onClick={() => resetForm()}
                      >
                        Cancel
                      </button>
                      <button type="submit" className={styles.SubmitButton}>
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateCommodity;
